export const SectionDivider = () => (
  <div className="px-[16px]! py-[12px]!">
    <div className="h-px w-full bg-[rgba(138,138,138,0.1)]" />
  </div>
);
